import { render, staticRenderFns } from "./orderTypeFilter.vue?vue&type=template&id=64789db4&"
import script from "./orderTypeFilter.vue?vue&type=script&lang=ts&"
export * from "./orderTypeFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports